export const HOME_CONSTANTS = {
  isBuilding: (coverType: string) => {
    if (!coverType) return false;
    return coverType !== 'HCB' && coverType !== 'HCC' && coverType !== 'C' && coverType !== 'LC' && coverType !== 'LCL';
  },
  isBuildingOnly: (coverType: string) => {
    if (!coverType) return false;
    return coverType === 'HBB' || coverType === 'HBC' || coverType === 'B' || coverType === 'LB' || coverType === 'LBL';
  },
  isContents: (coverType: string) => {
    if (!coverType) return false;
    return coverType !== 'HBB' && coverType !== 'HBC' && coverType !== 'B' && coverType !== 'LB' && coverType !== 'LBL';
  },
  isContentsOnly: (coverType: string) => {
    if (!coverType) return false;
    return coverType === 'HCB' || coverType === 'HCC' || coverType === 'C' || coverType === 'LC' || coverType === 'LCL';
  },
  isLandlords: (dwelling: any) => {
    if (!dwelling || !dwelling.owner_type || !dwelling.home_type) return false;
    return dwelling.owner_type === 'O' && dwelling.home_type === 'R';
  }
};
